import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "indicators",
      "datasources",
      "dashboards",
      "valueTypes",
      "locations",
      "data",
      "dashboardError",
      "user",
      "users",
      "roles",
      "permissions",
    ]),
    finalIndicatorList() {
      let list = [];
      const indicators = [...this.indicators]
        .map((ind) => ({ ...ind, name: ind.full_name }))
        .sort((a, b) => a.id - b.id);
      const groups = [...new Set(indicators.map((ind) => ind.program_area))];
      groups.forEach((group) => {
        list.push({
          id: group.replace(/s+/g, "_"),
          name: group,
          pa: true,
        });
        list = list.concat(indicators.filter((ind) => ind.program_area === group));
      });
      return list;
    },
    finalDatasourceList() {
      return this.datasources.map((source) => ({ ...source, name: source.datasource }));
    },
    finalValueTypeList() {
      return this.valueTypes.map((vt) => ({ ...vt, name: vt.value_type }));
    },
    finalLocationList() {
      return this.locations.sort((a, b) => {
        if (b.level == 2) return -1;
        return a.level - b.level;
      });
    },
  },
  methods: {
    ...mapActions("dashboard", [
      "loadIndicators",
      "loadDatasources",
      "loadValueTypes",
      "loadLocations",
      "loadDashboards",
      "loadData",
      "deleteDataPoint",
      "setDataLoaded",
      "uploadDashboard",
    ]),
    ...mapActions("users", [
      "loadusers",
      "loadroles",
      "createRole",
      "createPermission",
      "loadPermissions",
      "updateRole",
      "deleteRole",
    ]),
  },
};
